export function getConfig({
  prefix = "",
}: {
  prefix?: string
} = {}) {
  const headers = {
    "Tenant-Id": "teashop",
    "ZODANCE-VERSION": import.meta.env.VITE_ZODANCE_VERSION,
    "X-FROM": "teashop_merchant",
  } as any
  const dataSource = import.meta.env.VITE_DATA_SOURCE
  if (dataSource) {
    headers["X-DataSource"] = dataSource
  }

  return {
    headers,
    timeout: 30000,
    baseURL: import.meta.env.VITE_BASE_API + prefix,
    data: {},
  }
}
